export interface UserDevicesComponentConfig {
    title: string;
    subTitle: string;
    showStatus: boolean;
}

export enum USER_DEVICES_PAGE_MODE {
    VIEW_DEVICES = 'VIEW_DEVICES',
    VIEW_SESSIONS = 'VIEW_SESSIONS',
}

export const userDevicesComponentConfig: Record<USER_DEVICES_PAGE_MODE, UserDevicesComponentConfig> = {
    [USER_DEVICES_PAGE_MODE.VIEW_DEVICES]: {
        title: 'Oops! Too Many Active Devices',
        subTitle:
            'It looks like you’ve reached the limit of active devices. To access AdClarity on this \ndevice, please contact support or upgrade your plan for additional access.',
        showStatus: false,
    },
    [USER_DEVICES_PAGE_MODE.VIEW_SESSIONS]: {
        title: "You're Already Logged In Somewhere Else",
        subTitle:
            'You can only have one active session at a time. Please log out from your other device or \nupgrade your plan for additional AdClarity access.',
        showStatus: true,
    },
};
